import React, { useEffect } from 'react';
import { type Editor } from '@tiptap/react';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import styles from './RichText.module.css';

interface TiptapEditorProps {
    description: any;
    onChange: (richText: any) => void;
    label?: string;
    white?: boolean;
}

const RichText: React.FC<TiptapEditorProps> = ({
    description,
    onChange,
    label,
    white,
}) => {
    const editor = useEditor({
        extensions: [StarterKit.configure()],
        content: description,
        editorProps: {
            attributes: {
                class: `${styles.content} ${white ? styles.white : ''}`,
            },
        },
        onUpdate({ editor }) {
            onChange(editor.getHTML());
        },
    });

    useEffect(() => {
        if (editor && description !== editor.getHTML()) {
            editor.commands.setContent(description);
        }
    }, [description, editor]);

    return (
        <div className={styles.wrapper}>
            <label className={styles.infoLabel}>{label}</label>
            <MenuBar white={white} editor={editor} />
            <EditorContent editor={editor} />
        </div>
    );
};

export default RichText;

interface MenuBarProps {
    editor: Editor | null;
    white?: boolean;
}

const MenuBar: React.FC<MenuBarProps> = ({ editor, white }) => {
    if (!editor) {
        return null;
    }

    const toggleBold = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        editor.chain().focus().toggleBold().run();
    };

    const toggleBulletList = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        editor.chain().focus().toggleBulletList().run();
    };

    return (
        <div className={`${styles.menubar} + ${white ? styles.white : ''}`}>
            <button
                onClick={toggleBold}
                className={`${styles.menuButton} ${
                    editor.isActive('bold') ? styles.isActive : ''
                }`}
            >
                <FormatBoldIcon />
            </button>
            <button
                onClick={toggleBulletList}
                className={`${styles.menuButton} ${
                    editor.isActive('bulletList') ? styles.isActive : ''
                }`}
            >
                <FormatListBulletedIcon />
            </button>
        </div>
    );
};
